/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_My_DriveInputs */



/**
* | output |
* | --- |
* | "My Drive" |
*
* @param {Explorer_Nav_My_DriveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_my_drive = /** @type {((inputs?: Explorer_Nav_My_DriveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_My_DriveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mon Drive")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mein Laufwerk")
	if (locale === "it") return /** @type {LocalizedString} */ ("La mia guida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Моя поездка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mi unidad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("我的硬盘")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マイドライブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेरी ड्राइव")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Minha direção")
	return /** @type {LocalizedString} */ ("My Drive")
});